import { defineStore } from 'pinia'
import { ref } from 'vue'

type MobileSearchView = 'combined' | 'private' | 'public'

export const useMobileSearchStore = defineStore('search', () => {
  const isActive = ref(false)
  const query = ref('')
  const view = ref<MobileSearchView>('combined')

  const showSearch = () => {
    isActive.value = true
    view.value = 'combined'
  }

  const setView = (next: MobileSearchView) => {
    view.value = next
  }

  const close = () => {
    isActive.value = false
    query.value = ''
    view.value = 'combined'
  }

  return {
    isActive,
    query,
    view,
    showSearch,
    setView,
    close,
  }
})
